import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { authActions } from '../actions'
import { permissions } from '../utils'
import jwt_decode from 'jwt-decode'
import { NotPermission } from '../containers'

export const PrivateRoute = ({
  component: Component,
  token,
  changeNextPath,
  functionality = '',
  clearNextPath,
  path = '',
  logout,
  nextPath = '',
  ...rest
}) => {
  if (path === '/sair') {
    logout()
  } else if (!token) {
    changeNextPath(path)
  }

  if (functionality && token) {
    if (!permissions.canRead({ token, functionality })) {
      return <NotPermission />
    }
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (!!token) {
          if (nextPath) {
            const newPath = nextPath
            clearNextPath()
            return <Redirect to={newPath} />
          } else {
            return <Component {...props} />
          }
        } else {
          return <Redirect to="/login" />
        }
      }}
    />
  )
}

const mapStateToProps = state => ({
  token: state.auth.token,
  nextPath: state.auth.nextPath
})

const mapDispatchToProps = dispatch => {
  return {
    changeNextPath: nextPath => {
      dispatch(authActions.changeNextPath(nextPath))
    },
    clearNextPath: () => {
      dispatch(authActions.clearNextPath())
    },
    logout: () => {
      dispatch(authActions.logout())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute)



// WEBPACK FOOTER //
// ./src/routes/PrivateRoute.js